// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__[hash_base64-5]","active":"NavigationItem__active__[hash_base64-5]"};